import { Form, Input } from 'antd';
import React from 'react'

export const HandleCarouselTemplate = (value, setMediaLink, setExistingMediaIDs, setTemplateName, templates, setTemplateKey, setTemplateLanguage, setTemplatePreview, setMainBody, setCards, urlButtons, setMainBodyInputs, setCardData, setDynamicValues, bodyValues) => {
    setMediaLink('');
    setExistingMediaIDs([])
    setTemplateName(value);
    setTemplateKey((prevKey) => prevKey + 1);

    // Find the selected template
    const template = templates?.find((item) => item.name === value);

    // Set template-related state
    setTemplateLanguage(template?.language);
    setTemplatePreview(template);

    // Extract main body and dynamic values
    const { templateCards, mainBodyTemp } = extractTemplateSections(template);
    setMainBody(mainBodyTemp);
    setCards(templateCards)

    const mainBodyDynamicValue = mainBodyTemp?.text?.match(/{{\d+}}/g);
    if (mainBodyDynamicValue) {
        const inputs = generateInputsForDynamicValues(mainBodyDynamicValue, 'mainBody', null, setDynamicValues, null, bodyValues);
        setMainBodyInputs(inputs);
    } else {
        setMainBodyInputs([]);
    }

    // Handle templateCards
    if (templateCards && templateCards.length > 0) {
        const cardData = templateCards.map((card, index) => {
            const cardBodyDynamicValue = card.body?.text?.match(/{{\d+}}/g);
            // Return the card with dynamic inputs and media-related fields
            return {
                ...card,
                inputs: cardBodyDynamicValue
                    ? generateInputsForDynamicValues(cardBodyDynamicValue, 'card', index, setDynamicValues, setCardData)
                    : [],
                mediaType: 'Media', // Initialize mediaType
                mediaLink: '', // Initialize mediaLink
                mediaName: '', // Initialize mediaName
                useExternalUrl: false, // Initialize useExternalUrl
                urlButtons: urlButtons,

            };
        });
        setCardData(cardData); // Set cardData with media-related fields
    } else {
        setCardData([]);
    }
};
export const generateInputsForDynamicValues = (dynamicValues, type, cardIndex, setDynamicValues, setCardData, bodyValues) => {
    return dynamicValues.map((placeholder, index) => (
        <Form.Item
            key={index}
            label={`Value for ${placeholder}`}
            name={`${type}-${cardIndex}-${index}`}
            rules={[{
                required: true, message: `Please enter a value for ${placeholder}`
            }]}
            initialValue={bodyValues?.[index] || ''}
        >
            <Input
                type="text"
                value={bodyValues?.[index] || ''}
                placeholder={`Enter value for ${placeholder}`}
                onChange={(e) => handleInputChange(index, e.target.value, type, cardIndex, setDynamicValues, setCardData)}
            />
        </Form.Item>
    ));
}
export const handleUrlButtonChange = (cardIndex, buttonIndex, value, setCardButtonValues) => {
    setCardButtonValues(prevValues => ({
        ...prevValues,
        [`${cardIndex}_${buttonIndex}`]: value
    }));
};


const handleInputChange = (index, value, type, cardIndex, setDynamicValues, setCardData) => {
    if (type === 'mainBody') {
        setDynamicValues(prevValues => {
            const updatedValues = [...prevValues];
            updatedValues[index] = value;
            return updatedValues;
        });
    } else if (type === 'card') {
        setCardData(prevCards => {
            const updatedCards = [...prevCards];
            updatedCards[cardIndex].inputs[index] = value;
            return updatedCards;
        });
    }
};

const extractTemplateSections = (template) => {
    if (template) {
        let mainBodyTemp = null;
        let templateCards = [];

        // Process components to extract main body and carousel cards
        template.components.forEach(section => {
            if (section.type === "BODY") {
                mainBodyTemp = section;
            } else if (section.type === "CAROUSEL") {
                templateCards = section.cards.map(card => {
                    let cardHeader = null;
                    let cardBody = null;
                    let cardButtons = null;

                    // Extract header, body, and buttons for each card
                    card.components.forEach(cardSection => {
                        switch (cardSection.type) {
                            case "HEADER":
                                cardHeader = cardSection;
                                break;
                            case "BODY":
                                cardBody = cardSection;
                                break;
                            case "BUTTONS":
                                cardButtons = cardSection;
                                break;
                            default:
                                break;
                        }
                    });

                    return { header: cardHeader, body: cardBody, buttons: cardButtons };
                });
            }
        });
        return { mainBodyTemp, templateCards }
    }
}

export const HandleDynamicValues = (templatePreview, dynamicValues, setNewMessage) => {
    if (dynamicValues.length > 0) {
        const text = templatePreview?.components[1]?.text;
        let updatedText = text;
        dynamicValues.forEach((item, index) => {
            updatedText = updatedText?.replace(`{{${index + 1}}}`, item);
        });
        setNewMessage(updatedText); // Log the updated text array
    }
}

const generateContent = (type, id) => {
    switch (type) {
        case 'IMAGE':
            return { image: { id: id } };
        case 'VIDEO':
            return { video: { id: id } };
        case 'DOCUMENT':
            return { document: { id: id } };
        default:
            return {};
    }
};
export const generatePayload = (item, templateName, templateLanguage, cardData, dynamicValues, cardButtonValues) => {
    console.log("cardData...", cardData);
    const components = [];
    if (dynamicValues.length > 0) {
        components.push({
            type: "BODY",
            parameters: dynamicValues.map(value => ({
                type: "TEXT",
                text: value
            }))
        });
    }

    // Add the carousel component
    components.push({
        type: "CAROUSEL",
        cards: cardData.map((card, cardIndex) => ({
            card_index: cardIndex,
            components: [
                // Optional header
                ...(card.header ? [
                    {
                        type: "HEADER",
                        parameters: [
                            {
                                type: (() => {
                                    switch (card.header?.format) {
                                        case "IMAGE": return "IMAGE";
                                        case "VIDEO": return "VIDEO";
                                        case "DOCUMENT": return "DOCUMENT";
                                        default: return "TEXT";
                                    }
                                })(),
                                ...generateContent(card.header?.format, card.mediaLink),
                            },
                        ],
                    }
                ] : []),
                ...(card.inputs && card.inputs.length > 0 ? [
                    {
                        type: "BODY",
                        parameters: card.inputs.map(value => ({
                            type: "TEXT",
                            text: value
                        }))
                    }
                ] : []),
                ...(card.buttons.buttons ?? []).map((button, buttonIndex) => {
                    const key = `${cardIndex}_${buttonIndex}`;
                    const url = cardButtonValues?.[key];
                    return {
                        type: "BUTTON",
                        sub_type: button.type === "QUICK_REPLY" ? "QUICK_REPLY" : "URL",
                        index: buttonIndex,
                        ...(button.type === "URL" && url && {
                            parameters: [{ type: "text", text: url }]
                        }),
                        ...(button.type === "QUICK_REPLY" && {
                            parameters: [{ type: "payload", payload: "btntwo" }]
                        })
                    };
                })

            ],
        }))
    });

    return {
        messaging_product: "whatsapp",
        to: item,
        type: "template",
        template: {
            name: templateName,
            language: { code: templateLanguage },
            components
        }
    };
};

const normalizeTemplateValues = (values) => {
    if (!Array.isArray(values)) {
        return [];
    }

    return values
        .filter((value) => typeof value === 'string' || typeof value === 'number')
        .map((value) => String(value));
};

export const buildCarouselCardsForCampaign = (cardData, cardButtonValues = {}) => {
    if (!Array.isArray(cardData)) {
        return [];
    }

    return cardData.map((card, cardIndex) => {
        const buttonValues = {};

        Object.entries(cardButtonValues || {}).forEach(([key, value]) => {
            const [cardIdx, buttonIdx] = String(key).split('_');
            if (Number(cardIdx) === cardIndex && value !== undefined && value !== null && value !== '') {
                buttonValues[buttonIdx] = String(value);
            }
        });

        return {
            media_id: card.mediaLink || '',
            media_type: card.header?.format || null,
            body_values: normalizeTemplateValues(card.inputs),
            button_values: buttonValues,
        };
    });
};

export const HandleUploadImage = (path, name, setExistingMediaIDs, setCardData, currentCardIndex, setOpenMediaModel) => {
    if (path) {
        setExistingMediaIDs(prevMediaIDs => {
            const updatedMediaIDs = [...prevMediaIDs];
            updatedMediaIDs[currentCardIndex] = path; // Replace the media ID at the current index
            return updatedMediaIDs;
        });
        setCardData((prevData) =>
            prevData.map((card, index) =>
                index === currentCardIndex
                    ? { ...card, mediaLink: path, mediaName: name }
                    : card
            )
        );
        setOpenMediaModel(false);
    }
};